import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb2a5f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_datacollect_add" }
const _hoisted_2 = { class: "form_area" }
const _hoisted_3 = { class: "form_header" }
const _hoisted_4 = { class: "el-descriptions__title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑模式")
const _hoisted_6 = { style: {"padding":"15px"} }
const _hoisted_7 = { style: {"margin-bottom":"15px","display":"flex","align-items":"center"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"width":"100px","font-weight":"500"} }, "选择数据模板：", -1))
const _hoisted_9 = {
  key: 0,
  class: "dynamic_form"
}
const _hoisted_10 = {
  key: 0,
  style: {"max-width":"500px","width":"100%"}
}
const _hoisted_11 = { class: "readonly_field" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  style: {"color":"#999"}
}
const _hoisted_14 = {
  key: 1,
  style: {"white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("无编辑权限")
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  style: {"margin-bottom":"8px"}
}
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_20 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_21 = {
  key: 0,
  style: {"margin-top":"15px","padding-left":"130px","display":"flex","align-items":"center"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"width":"130px","font-weight":"500","text-align":"right"} }, "下一道填写人：", -1))
const _hoisted_23 = {
  key: 0,
  style: {"margin-left":"10px","color":"#909399","font-size":"12px"}
}
const _hoisted_24 = {
  key: 1,
  style: {"margin-left":"10px","color":"#e6a23c","font-size":"12px"}
}
const _hoisted_25 = { style: {"margin-top":"15px","padding-left":"130px"} }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消编辑")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_28 = {
  key: 1,
  style: {"color":"#999","text-align":"center","padding":"30px 0"}
}
const _hoisted_29 = { class: "data_list_area" }
const _hoisted_30 = { class: "form_header" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-descriptions__title" }, "已提交数据", -1))
const _hoisted_32 = { style: {"display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("导出Excel")
const _hoisted_35 = { style: {"padding":"8px 15px","background":"#f5f7fa","border-bottom":"1px solid #ebeef5"} }
const _hoisted_36 = {
  key: 0,
  style: {"font-size":"13px","color":"#606266","font-weight":"500"}
}
const _hoisted_37 = {
  key: 1,
  style: {"font-size":"13px","color":"#606266","font-weight":"500","width":"78px"}
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_39 = { style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("+ 添加查询条件")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#909399"} }, "多个条件同时满足才会被查出", -1))
const _hoisted_44 = { style: {"padding":"15px"} }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("查看项目信息")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("所有附件")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("语音提醒")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_50 = ["href"]
const _hoisted_51 = {
  key: 0,
  style: {"color":"#999"}
}
const _hoisted_52 = { key: 2 }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("已完善")
const _hoisted_54 = { style: {"margin-top":"10px","display":"flex","justify-content":"flex-end"} }
const _hoisted_55 = { style: {"margin-bottom":"15px"} }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"6px","font-weight":"500"} }, "提醒人员：", -1))
const _hoisted_57 = { style: {"color":"#909399","font-size":"12px","margin-bottom":"10px"} }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("发送语音提醒")
const _hoisted_60 = {
  class: "stat_area",
  style: {"margin-top":"25px","padding":"15px","border":"1px solid #ebeef5","border-radius":"6px","background":"#fff"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-descriptions__title",
  style: {"margin-bottom":"15px"}
}, "数据收集统计", -1))
const _hoisted_62 = { style: {"display":"flex","align-items":"center","flex-wrap":"wrap","gap":"12px","margin-bottom":"15px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-right":"6px"} }, "数据模板类型：", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-right":"6px"} }, "分组统计字段：", -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode("统计")
const _hoisted_66 = {
  key: 0,
  style: {"display":"flex","gap":"20px","flex-wrap":"wrap"}
}
const _hoisted_67 = { style: {"flex":"1","min-width":"360px"} }
const _hoisted_68 = { style: {"font-weight":"500","margin-bottom":"8px"} }
const _hoisted_69 = { style: {"width":"380px"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"500","margin-bottom":"8px"} }, "占比分布（饼图）", -1))
const _hoisted_71 = {
  key: 1,
  style: {"color":"#909399","font-size":"13px"}
}
const _hoisted_72 = { class: "my-header" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("保 存")

import { ref, onMounted, onBeforeUnmount, reactive, computed, nextTick } from 'vue';
import ProjectInfoEdit from '@/components/ProjectInfoEdit.vue';
import ProjectAllFiles from '@/components/ProjectAllFiles.vue';
	import { useRoute } from 'vue-router';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { Search, Close } from '@element-plus/icons-vue';
	import * as echarts from 'echarts';
	import { apiName, requestMyuser } from '@/api/api';
	import { requestProjectAllList } from '@/api/xmApi';
	import {
		reqDataCollectGetTemplateAll,
		reqDataCollectSaveData,
		reqDataCollectDataList,
		reqDataCollectDataDelete,
		reqDataCollectUpdateData,
		reqDataCollectSendVoiceNotify,
		reqDataCollectGetEditableUsers,
		reqDataCollectStat,
		reqDataCollectExecSql,
		reqDataCollectExport
	} from '@/api/datacollectApi';

	
export default /*#__PURE__*/_defineComponent({
  name: 'DataCollectAdd',
  setup(__props) {

	const apiname = ref(apiName);
	const userList = ref<any>({});
	const route = useRoute();
	// 下一道填写人
	const nextHandler = ref<string>('');
	// 编辑模式
	const editMode = ref<boolean>(false);
	// 表格内容显示模式：true=单行（超出隐藏，悬停显示完整）；false=多行（换行完整展示）
	const singleLine = ref<boolean>(true);
	const editingId = ref<number>(0);
	// 模板+字段列表
	const templateAllList = ref<any[]>([]);
	// 当前选中模板
	const selectedTemplateId = ref<number>(0);
	// 当前模板的字段
	const currentFields = ref<any[]>([]);
	// 表单数据
	const formData = reactive<any>({});
	// “数据库来源的下拉选择”字段的候选项（按字段 id 索引）
	const fieldDbOptions = reactive<Record<number, any[]>>({});

	// 数据列表
	const dataList = ref<any[]>([]);
	const searchTemplateId = ref<string>('');
	const searchTemplateName = ref<string>('');
	// 填写内容查询：支持动态增加多个条件（多条件之间为"且"关系）
	// fieldid=字段；empty=查询方式（empty/notempty/range）；text=模糊内容；daterange=日期区间（仅日期字段）
const newSearchItem = () => ({ fieldid: 0, empty: '', text: '', daterange: null as any });
	const searchItems = ref<any[]>([newSearchItem()]);
	const addSearchItem = () => {
		searchItems.value.push(newSearchItem());
	};
	const removeSearchItem = (idx: number) => {
		searchItems.value.splice(idx, 1);
		if (searchItems.value.length === 0) searchItems.value.push(newSearchItem());
	};
	// 切换字段时清空该条条件的查询方式与内容
	const onSearchItemFieldChange = (item: any) => {
		item.empty = '';
		item.text = '';
		item.daterange = null;
	};
	// 当前条件所选字段的类型（用于日期字段显示"时间区间"筛选）
	const getSearchFieldType = (item: any): string => {
		const f = searchFieldList.value.find((x: any) => x.id === item.fieldid);
		return f ? (f.fieldtype || '') : '';
	};
	const isDateSearchField = (item: any): boolean => getSearchFieldType(item) === 'date';
	// 取有效条件（字段 + 查询方式均需选择；时间区间需起止日期都选）
	const getValidSearchItems = (): any[] => {
		const arr: any[] = [];
		searchItems.value.forEach((i: any) => {
			if (Number(i.fieldid) <= 0 || String(i.empty) === '') return;
			if (String(i.empty) === 'range') {
				const dr = i.daterange || [];
				if (!dr || dr.length !== 2 || !dr[0] || !dr[1]) return;
				arr.push({ fieldid: i.fieldid, empty: 'range', text: '', datestart: dr[0], dateend: dr[1] });
				return;
			}
			arr.push({ fieldid: i.fieldid, empty: i.empty, text: i.text || '' });
		});
		return arr;
	};
	const searchDateRange = ref<any>(null);
	const searchFieldList = ref<any[]>([]);
	const pageIndex = ref<number>(1);
	const pageSize = ref<number>(20);
	const total = ref<number>(0);

	// 数据收集统计
	const statTemplateId = ref<number>(0);      // 统计所选模板
	const statFieldList = ref<any[]>([]);       // 统计所选模板的字段列表
	const statFieldId = ref<number>(0);         // 分组统计字段
	const statRows = ref<any[]>([]);            // 统计结果（按次数从大到小）
	const statFieldName = ref<string>('');      // 统计字段名称
	let statChart: any = null;                  // 饼图实例
	const statChartRef = ref<any>(null);

	// 当前模板的所有可编辑人员列表
	const currentEditableUsers = computed(() => {
		const tpl = templateAllList.value.find((t: any) => t.id === selectedTemplateId.value);
		if (!tpl || !tpl.fields) return [];
		const userSet = new Set<string>();
		let hasEmpty = false;
		for (const f of tpl.fields) {
			const eu = (f.editableusers || '').trim();
			if (!eu) { hasEmpty = true; continue; }
			eu.split(',').map((u: string) => u.trim()).filter((u: string) => u).forEach((u: string) => userSet.add(u));
		}
		// 如果有字段editableusers为空，表示所有人可编辑，需要从所有字段中收集用户名
		// 但实际上为空表示"所有人"，这里返回所有字段中出现过的用户
		return Array.from(userSet);
	});

	// 当前模板允许选择"无（信息已完善）"的人员名单（在模板配置中指定）
	const completeUsers = computed<string[]>(() => {
		const tpl = templateAllList.value.find((t: any) => t.id === selectedTemplateId.value);
		if (!tpl || !tpl.complete_users) return [];
		return String(tpl.complete_users).split(',').map((u: string) => u.trim()).filter((u: string) => u);
	});

	// 当前登录用户是否可将"下一道填写人"选为"无（信息已完善）"
	// 规则：名单为空表示所有人可选"无"；名单不为空时，只有名单内的人员可选"无"
	const allowComplete = computed(() => {
		if (completeUsers.value.length === 0) return true;
		const userName = userList.value.name || '';
		return !!userName && completeUsers.value.includes(userName);
	});

	onMounted(() => {
		// 附件支持 Ctrl + V 粘贴上传（整页监听，落到当前选中的附件栏目）
		document.addEventListener('paste', onPaste);
		// 项目列表：用于订单信息计划表按批次号关联项目
		loadProjectList();
		requestMyuser().then((res: any) => {
			if (res.status === 1) {
				userList.value = res.datalist[0];
			}
		});
		// 先加载模板，再处理编辑模式，避免竞态条件
		loadTemplateAll().then(() => {
			const editId = route.query.editId;
			if (editId) {
				autoEditById(Number(editId));
			}
		});
});

onBeforeUnmount(() => {
	document.removeEventListener('paste', onPaste);
});

	// 判断当前用户是否可编辑某字段
	// editableusers为空表示所有人可编辑，否则只有列表中的用户可编辑
	const canEditField = (field: any): boolean => {
		const editableUsers = field.editableusers || '';
		if (!editableUsers || editableUsers.trim() === '') return true;
		const userName = userList.value.name || '';
		if (!userName) return false;
		const users = editableUsers.split(',').map((u: string) => u.trim());
		return users.includes(userName);
	};

	// 加载所有模板及其字段
	const loadTemplateAll = (): Promise<void> => {
		return new Promise((resolve) => {
			reqDataCollectGetTemplateAll({}).then((res: any) => {
				if (res.status === 1) {
					templateAllList.value = res.datalist || [];
					// 默认选中第一个模板
					if (templateAllList.value.length > 0 && !searchTemplateId.value) {
						searchTemplateId.value = String(templateAllList.value[0].id);
						searchFieldList.value = templateAllList.value[0].fields || [];
					}
				}
				loadDataList();
				resolve();
			}).catch(() => resolve());
		});
	};

	// 选择模板后显示字段
	const onTemplateChange = (val: number) => {
		Object.keys(formData).forEach(k => delete formData[k]);
		nextHandler.value = '';
		if (val === 0) {
			currentFields.value = [];
			activeAttachFieldId.value = 0;
			return;
			}
			const tpl = templateAllList.value.find((t: any) => t.id === val);
			if (tpl) {
			currentFields.value = tpl.fields || [];
			initActiveAttachField();
			currentFields.value.forEach((f: any) => {
				if (f.fieldtype === 'attachment') {
					formData[f.id] = [];
				} else {
					formData[f.id] = '';
				}
			});
			loadDbListOptions(currentFields.value);
		}
	};

	// 加载“数据库来源的下拉选择”字段的候选项（执行配置 SQL）
	const loadDbListOptions = (fields: any[]) => {
		Object.keys(fieldDbOptions).forEach(k => delete fieldDbOptions[k]);
		fields.forEach((f: any) => {
			if (f.fieldtype === 'dblist' && f.fieldoptions) {
				reqDataCollectExecSql({ sql: f.fieldoptions }).then((res: any) => {
					if (res.status === 1 && Array.isArray(res.datalist)) {
						// 保存和显示都使用返回结果的 showfield 字段
						fieldDbOptions[f.id] = res.datalist
							.map((row: any) => (row && row.showfield != null ? String(row.showfield) : ''))
							.filter((v: string) => v !== '')
							.map((v: string) => ({ value: v, label: v }));
					} else {
						fieldDbOptions[f.id] = [];
					}
				}).catch(() => {
					fieldDbOptions[f.id] = [];
				});
			}
		});
	};

	// 获取某个字段的数据库下拉候选项
	const getDbOptions = (field: any): any[] => {
		return fieldDbOptions[field.id] || [];
	};

	// 统计-选择模板后加载该模板字段列表
	const onStatTemplateChange = (val: number) => {
		statFieldId.value = 0;
		statRows.value = [];
		statFieldName.value = '';
		const tpl = templateAllList.value.find((t: any) => t.id === val);
		statFieldList.value = tpl ? (tpl.fields || []) : [];
	};

	// 统计-点击统计
	const doStat = () => {
		if (!statTemplateId.value || !statFieldId.value) {
			ElMessage.warning('请先选择数据模板和分组统计字段');
			return;
		}
		reqDataCollectStat({
			templateid: statTemplateId.value,
			fieldid: statFieldId.value
		}).then((res: any) => {
			if (res.status === 1) {
				statRows.value = res.datalist.rows || [];
				statFieldName.value = res.datalist.fieldname || '';
				renderPie();
			} else {
				ElMessage.error(res.msg || '统计失败');
			}
		});
	};

	// 统计-渲染饼图
	const renderPie = () => {
		nextTick(() => {
			if (!statChartRef.value) return;
			if (!statChart) {
				statChart = echarts.init(statChartRef.value);
			}
			const data = statRows.value.map((r: any) => ({
				name: r.name,
				value: r.value
			}));
			statChart.setOption({
				tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
				legend: { type: 'scroll', orient: 'vertical', right: 10, top: 20, bottom: 20 },
				series: [
					{
						name: statFieldName.value || '统计',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['40%', '50%'],
						avoidLabelOverlap: true,
						itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
						label: { show: true, formatter: '{b}: {c}' },
						data: data
					}
				]
			});
			statChart.resize();
		});
	};

	// 附件上传成功（追加模式）
	const onUploadSuccessSingle = (fieldId: number, res: any, file: any) => {
		if (res.errno === 0 && res.data && res.data[0]) {
			if (!formData[fieldId]) formData[fieldId] = [];
			const url = res.data[0].url || '';
			formData[fieldId].push({
				name: file.name,
				url: url
			});
		}
	};

	// 移除附件
	const removeAttachFile = (fieldId: number, index: number) => {
		if (formData[fieldId] && Array.isArray(formData[fieldId])) {
			formData[fieldId].splice(index, 1);
		}
	};

	// ===== 订单信息计划表：按批次号关联项目（查看项目信息 / 所有附件）=====
const projectList = ref<any[]>([])
const loadProjectList = () => {
	requestProjectAllList({}).then((res: any) => {
		projectList.value = (res && res.datalist) || []
	})
}
// 取某行数据的"批次号"字段值
const getRowBatchno = (row: any): string => {
	const fvs = parseFieldValues(row.fieldvalues)
	for (let i = 0; i < fvs.length; i++) {
		if (fvs[i].fieldname === '批次号') return fvs[i].value || ''
	}
	return ''
}
// 数据模板=订单信息计划表 且 批次号能匹配到项目编号时，返回对应项目（否则返回 null，不显示按钮）
const getLinkedProject = (row: any): any => {
	if (!row) return null
	if (String(row.templatename || '').indexOf('订单信息计划表') < 0) return null
	const bn = getRowBatchno(row)
	if (!bn) return null
	return projectList.value.find((p: any) => String(p.code) === String(bn)) || null
}
const projectInfoShow = ref<boolean>(false)
const projectInfoRef = ref<any>(null)
const projectInfoSaving = ref<boolean>(false)
const curProject = ref<any>({})
const openProjectInfo = (p: any) => {
	curProject.value = p || {}
	projectInfoShow.value = true
	nextTick(() => { if (projectInfoRef.value) projectInfoRef.value.load() })
}
const saveProjectInfo = () => {
	if (!projectInfoRef.value) return
	projectInfoSaving.value = true
	projectInfoRef.value.save()
	setTimeout(() => { projectInfoSaving.value = false }, 800)
}
const onProjectInfoSaved = () => {
	projectInfoShow.value = false
	projectInfoSaving.value = false
}
const allFilesRef = ref<any>(null)
const openAllFiles = (p: any) => {
	if (allFilesRef.value && p) allFilesRef.value.open(p.uuid, p.projectname)
}

// ===== 附件 Ctrl+V 粘贴上传 =====
	// 本页可能有多个附件栏目，粘贴必须明确归属：以“最近点击过的附件栏目”作为粘贴目标
	const activeAttachFieldId = ref<number>(0);
	const pasteUploading = ref<boolean>(false);
	// 点击（含点击“上传附件”按钮、移除按钮等）即把该栏目设为粘贴目标
	const setActiveAttachField = (fieldId: number) => {
		activeAttachFieldId.value = fieldId;
	};
	// 默认粘贴目标：当前模板的第一个附件栏目
	const initActiveAttachField = () => {
		const first: any = currentFields.value.find((f: any) => f.fieldtype === 'attachment');
		activeAttachFieldId.value = first ? first.id : 0;
	};
	// 上传单个粘贴文件（与 el-upload 走同一接口 /frame/uploadfile1，表单字段名 file）
	const uploadPasteFile = (fieldId: number, file: File) => {
		pasteUploading.value = true;
		const fd = new FormData();
		fd.append('file', file, file.name || ('paste_' + Date.now()));
		fetch(`${apiname.value}/frame/uploadfile1`, { method: 'POST', credentials: 'same-origin', body: fd })
			.then((r: any) => r.json())
			.then((res: any) => {
				if (res && res.errno === 0 && res.data && res.data[0]) {
					const url = res.data[0].url || '';
					const name = res.data[0].name ? decodeURIComponent(res.data[0].name) : (file.name || '附件');
					if (!formData[fieldId]) formData[fieldId] = [];
					formData[fieldId].push({ name, url });
					ElMessage({ message: '附件已上传', type: 'success', duration: 800 });
				} else {
					ElMessage({ message: (res && res.msg) || '附件上传失败', type: 'error', duration: 800 });
				}
			})
			.catch(() => {
				ElMessage({ message: '附件上传失败', type: 'error', duration: 800 });
			})
			.finally(() => {
				pasteUploading.value = false;
			});
	};
	// 全局粘贴：剪贴板中带文件时上传，纯文本粘贴不拦截（不影响输入框正常粘贴）
	const onPaste = (e: ClipboardEvent) => {
		const items = e.clipboardData && e.clipboardData.items;
		if (!items) return;
		const files: File[] = [];
		for (let i = 0; i < items.length; i++) {
			const it: any = items[i];
			if (it && it.kind === 'file' && it.getAsFile) {
				const f = it.getAsFile();
				if (f) files.push(f);
			}
		}
		if (files.length === 0) return;
		e.preventDefault();
		const field: any = currentFields.value.find((f: any) => f.id === activeAttachFieldId.value && f.fieldtype === 'attachment');
		if (!field) {
			ElMessage.warning('请先点击要粘贴到的附件栏目的“上传附件”按钮，再按 Ctrl + V');
			return;
		}
		if (!canEditField(field)) {
			ElMessage.warning('当前栏目无编辑权限，无法粘贴附件');
			return;
		}
		files.forEach((f: File) => uploadPasteFile(field.id, f));
	};

	// 提交保存（新增或编辑）
	const submitData = () => {
		if (selectedTemplateId.value === 0) {
			ElMessage.warning('请选择数据模板');
			return;
		}
		// 模板配置为"不可选无"时，下一道填写人必须指定具体人员
		if (!allowComplete.value && !nextHandler.value) {
			ElMessage.warning('您不在该模板"可选无"的人员名单内，必须指定下一道填写人');
			return;
		}
		// 构建fieldvalues
		const values: any[] = [];
		currentFields.value.forEach((f: any) => {
			let val = formData[f.id];
			if (f.fieldtype === 'attachment') {
				if (Array.isArray(val)) {
					val = val.map((v: any) => v.url || (v.response && v.response.data && v.response.data[0] && v.response.data[0].url) || '').filter((u: string) => u).join(',');
				} else {
					val = val || '';
				}
			} else if (typeof val === 'string') {
				// 统一换行符：Windows(\r\n) / 旧Mac(\r) -> \n
				val = val.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
				if (f.fieldtype === 'textarea') {
					// 多行文本：保留换行。
					// JSON.stringify 会将其转义为 \n，后端再对反斜杠做 MySQL 转义后入库，
					// 读取时 json 可原样还原为换行（列表已用 pre-wrap 显示）。
					// 仅把连续 3 个以上换行压缩为 2 个，避免大量空行
					val = val.replace(/\n{3,}/g, '\n\n').trim();
				} else {
					// 单行文本：换行统一替换为空格，避免不可见换行影响显示与查询
					val = val.replace(/\n/g, ' ').trim();
				}
			}
			values.push({
				fieldid: f.id,
				fieldname: f.fieldname,
				fieldtype: f.fieldtype,
				value: val || ''
			});
		});

		if (editMode.value) {
			// 编辑模式 - 更新
			reqDataCollectUpdateData({
				id: editingId.value,
				fieldvalues: JSON.stringify(values),
				nexthandler: nextHandler.value
			}).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '修改成功', type: 'success', duration: 500 });
					cancelEdit();
					loadDataList();
				} else {
					ElMessage({ message: res.msg || '修改失败', type: 'error', duration: 500 });
				}
			});
		} else {
			// 新增模式
			const tpl = templateAllList.value.find((t: any) => t.id === selectedTemplateId.value);
			reqDataCollectSaveData({
				templateid: selectedTemplateId.value,
				templatename: tpl ? tpl.name : '',
				fieldvalues: JSON.stringify(values),
				nexthandler: nextHandler.value
			}).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '保存成功', type: 'success', duration: 500 });
					resetForm();
					loadDataList();
				} else {
					ElMessage({ message: res.msg || '保存失败', type: 'error', duration: 500 });
				}
			});
		}
	};

	// 编辑数据 - 加载行数据到表单
	const editData = (row: any) => {
		editMode.value = true;
		editingId.value = row.id;
		selectedTemplateId.value = row.templateid;
		const tpl = templateAllList.value.find((t: any) => t.id === row.templateid);
		if (tpl) {
			currentFields.value = tpl.fields || [];
			loadDbListOptions(currentFields.value);
			initActiveAttachField();
		}
		// 解析已有的fieldvalues并填充
		const fieldValues = parseFieldValues(row.fieldvalues);
		Object.keys(formData).forEach(k => delete formData[k]);
		currentFields.value.forEach((f: any) => {
			const fv = fieldValues.find((v: any) => v.fieldid === f.id);
			if (fv) {
				if (f.fieldtype === 'attachment') {
					formData[f.id] = parseAttachUrls(fv.value).map((url: string, idx: number) => ({
						name: '附件' + (idx + 1),
						url: url
					}));
				} else {
					formData[f.id] = fv.value || '';
				}
			} else {
				formData[f.id] = f.fieldtype === 'attachment' ? [] : '';
			}
		});
		// 回填下一道填写人
		nextHandler.value = row.nexthandler || '';
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	// 从工作台跳转自动编辑
	const autoEditById = (editId: number) => {
		// 先加载数据列表找到对应行
		reqDataCollectDataList({ pageIndex: 1, pageSize: 1, id: editId }).then((res: any) => {
			if (res.code === 0 || res.data) {
				const data = res.data || res.DataMap || [];
				if (Array.isArray(data) && data.length > 0) {
					const row = data[0].cell || data[0];
					editData(row);
				}
			}
		});
	};

	// 取消编辑
	const cancelEdit = () => {
		editMode.value = false;
		editingId.value = 0;
		selectedTemplateId.value = 0;
		currentFields.value = [];
		activeAttachFieldId.value = 0;
		nextHandler.value = '';
		Object.keys(formData).forEach(k => delete formData[k]);
	};

	// 重置表单
	const resetForm = () => {
		currentFields.value.forEach((f: any) => {
			if (f.fieldtype === 'attachment') {
				formData[f.id] = [];
			} else {
				formData[f.id] = '';
			}
		});
	};

	// 选择筛选模板时加载字段列表
	const onSearchTemplateChange = (val: string) => {
		// 切换模板后字段变化，重置为一组空条件
		searchItems.value = [newSearchItem()];
		if (val) {
			const tpl = templateAllList.value.find((t: any) => String(t.id) === val);
			searchFieldList.value = tpl ? (tpl.fields || []) : [];
		} else {
			searchFieldList.value = [];
		}
		pageIndex.value = 1;
		loadDataList();
	};

	const resetFieldSearch = () => {
		if (templateAllList.value.length > 0) {
			searchTemplateId.value = String(templateAllList.value[0].id);
			searchFieldList.value = templateAllList.value[0].fields || [];
		} else {
			searchTemplateId.value = '';
			searchFieldList.value = [];
		}
		searchItems.value = [newSearchItem()];
		pageIndex.value = 1;
		loadDataList();
	};

	// 条件查询时重置页码到第一页
	const searchDataList = () => {
		pageIndex.value = 1;
		loadDataList();
	};

	// 导出 Excel（按当前查询条件导出全部数据）
	const exporting = ref<boolean>(false);
	const exportExcel = () => {
		exporting.value = true;
		const validItems = getValidSearchItems();
		reqDataCollectExport({
			templateid: searchTemplateId.value,
			templatename: searchTemplateName.value,
			searchitems: JSON.stringify(validItems),
			searchfieldid: validItems.length ? validItems[0].fieldid : '',
			searchempty: validItems.length ? validItems[0].empty : '',
			searchtext: validItems.length ? validItems[0].text : '',
			searchdatestart: searchDateRange.value && searchDateRange.value.length === 2 ? searchDateRange.value[0] : '',
			searchdateend: searchDateRange.value && searchDateRange.value.length === 2 ? searchDateRange.value[1] : ''
		}).then((res: any) => {
			exporting.value = false;
			if (res.status === 1 && res.datalist) {
				// 后端返回 /imgfile/xxx.xlsx，经 main.go 的 SetStaticPath("/imgfile","./imgfile") 映射到静态目录
				// 此处已是根路径，无需再拼 /api 前缀；用 <a download> 触发自动下载
				const path: string = String(res.datalist);
				const url = path.startsWith('http') ? path : `${window.location.origin}${path}`;
				const ts = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-');
				const a = document.createElement('a');
				a.href = url;
				a.target = '_blank';
				a.download = `数据收集导出_${ts}.xlsx`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				ElMessage({ message: '导出成功，已开始下载', type: 'success', duration: 1000 });
			} else {
				ElMessage({ message: res.msg || '导出失败', type: 'error', duration: 800 });
			}
		}).catch(() => {
			exporting.value = false;
			ElMessage({ message: '导出失败', type: 'error', duration: 800 });
		});
	};

	// 加载数据列表
	const loadDataList = () => {
		const validItems = getValidSearchItems();
		reqDataCollectDataList({
			pageIndex: pageIndex.value,
			pageSize: pageSize.value,
			templateid: searchTemplateId.value,
			templatename: searchTemplateName.value,
			// 多组填写内容条件（JSON 数组）
			searchitems: JSON.stringify(validItems),
			// 兼容旧参数：取第一组条件
			searchfieldid: validItems.length ? validItems[0].fieldid : '',
			searchempty: validItems.length ? validItems[0].empty : '',
			searchtext: validItems.length ? validItems[0].text : '',
			searchdatestart: searchDateRange.value && searchDateRange.value.length === 2 ? searchDateRange.value[0] : '',
			searchdateend: searchDateRange.value && searchDateRange.value.length === 2 ? searchDateRange.value[1] : ''
		}).then((res: any) => {
			if (res.code === 0 || res.data) {
				const data = res.data || res.DataMap || [];
				if (Array.isArray(data)) {
					dataList.value = data.map((item: any) => item.cell || item);
				} else {
					dataList.value = [];
				}
				total.value = res.totalCount || res.total || 0;
			}
		});
	};

	// 删除数据
	const deleteData = (row: any) => {
		ElMessageBox.confirm('确定要删除该条数据吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqDataCollectDataDelete({ id: row.id }).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '删除成功', type: 'success', duration: 500 });
					loadDataList();
				}
			});
		}).catch(() => {});
	};

	// 语音提醒相关
	const voiceDialogShow = ref<boolean>(false);
	const voiceSelectedUser = ref<string>('');
	const voiceEditableUsers = ref<string[]>([]);
	const voiceTemplateName = ref<string>('');
	const voiceSending = ref<boolean>(false);

	// 打开语音提醒弹窗
	const openVoiceDialog = (row: any) => {
		voiceSelectedUser.value = '';
		voiceEditableUsers.value = [];
		voiceTemplateName.value = row.templatename || '';
		voiceDialogShow.value = true;
		// 加载该模板的可编辑人员列表
		reqDataCollectGetEditableUsers({ templateid: row.templateid }).then((res: any) => {
			if (res.status === 1 && res.datalist) {
				voiceEditableUsers.value = res.datalist;
			}
		});
	};

	// 发送语音提醒
	const sendVoiceNotify = () => {
		if (!voiceSelectedUser.value) {
			ElMessage.warning('请选择提醒人员');
			return;
		}
		voiceSending.value = true;
		reqDataCollectSendVoiceNotify({
			username: voiceSelectedUser.value,
			templatename: voiceTemplateName.value
		}).then((res: any) => {
			voiceSending.value = false;
			if (res.status === 1) {
				ElMessage({ message: '语音提醒发送成功', type: 'success', duration: 500 });
				voiceDialogShow.value = false;
			} else {
				ElMessage({ message: res.msg || '语音提醒发送失败', type: 'error', duration: 500 });
			}
		}).catch(() => {
			voiceSending.value = false;
		});
	};

	// 工具函数
	const parseOptions = (optionsStr: string): string[] => {
		if (!optionsStr) return [];
		try {
			const arr = JSON.parse(optionsStr);
			return Array.isArray(arr) ? arr : [];
		} catch (e) {
			return [];
		}
	};

	// 动态表格列：根据当前数据列表自动提取所有字段作为独立列
	const dynamicTableColumns = computed(() => {
		// 如果选择了筛选模板，直接用该模板的字段
		if (searchTemplateId.value) {
			const tpl = templateAllList.value.find((t: any) => String(t.id) === searchTemplateId.value);
			if (tpl && tpl.fields) {
				return tpl.fields.map((f: any) => ({ fieldid: f.id, fieldname: f.fieldname, fieldtype: f.fieldtype }));
			}
		}
		// 否则从当前数据中提取所有唯一字段
		const fieldMap = new Map<number, { fieldid: number; fieldname: string; fieldtype: string }>();
		for (const row of dataList.value) {
			const fvs = parseFieldValues(row.fieldvalues);
			for (const fv of fvs) {
				if (!fieldMap.has(fv.fieldid)) {
					fieldMap.set(fv.fieldid, { fieldid: fv.fieldid, fieldname: fv.fieldname, fieldtype: fv.fieldtype || 'text' });
				}
			}
		}
		return Array.from(fieldMap.values());
	});

	// 从fieldvalues JSON中提取指定字段的值或类型
	const getFieldValue = (fieldvaluesStr: string, fieldId: number, prop: string): string => {
		const fvs = parseFieldValues(fieldvaluesStr);
		const fv = fvs.find((v: any) => v.fieldid === fieldId);
		if (!fv) return '';
		if (prop === 'type') return fv.fieldtype || '';
		return fv.value || '';
	};

	const parseFieldValues = (jsonStr: string): any[] => {
		if (!jsonStr) return [];
		try {
			return JSON.parse(jsonStr);
		} catch (e) {
			return [];
		}
	};

	const parseAttachUrls = (val: any): string[] => {
		if (!val) return [];
		if (Array.isArray(val)) {
			return val.map((v: any) => (typeof v === 'string' ? v : (v && v.url) || '').toString()).filter((u: string) => u);
		}
		if (typeof val === 'string') {
			return val.split(',').filter((u: string) => u);
		}
		// 其它类型（如对象）尝试取 url 字段
		if (val.url) return [val.url];
		return [];
	};

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(editMode.value ? '编辑数据' : '数据收集填写'), 1),
        (editMode.value)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "warning",
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_el_select, {
            modelValue: selectedTemplateId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTemplateId).value = $event)),
            placeholder: "请选择数据模板",
            style: {"width":"300px"},
            onChange: onTemplateChange,
            filterable: "",
            disabled: editMode.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "",
                value: 0
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateAllList.value, (tpl) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: tpl.id,
                  label: tpl.name,
                  value: tpl.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        (currentFields.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_form, {
                "label-width": "130px",
                class: "two-col-form"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFields.value, (field) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: field.id,
                      label: field.fieldname,
                      class: "two-col-item"
                    }, {
                      default: _withCtx(() => [
                        (!canEditField(field))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                (field.fieldtype==='attachment')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseAttachUrls(formData[field.id] || ''), (af, ai) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          key: ai,
                                          href: `${apiname.value}${af}`,
                                          target: "_blank",
                                          style: {"color":"#409EFF","margin-right":"6px"}
                                        }, "附件" + _toDisplayString(ai+1), 9, _hoisted_12))
                                      }), 128)),
                                      (parseAttachUrls(formData[field.id] || '').length===0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "无"))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (field.fieldtype==='textarea')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(formData[field.id] || '-'), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(formData[field.id] || '-'), 1)
                                      ], 64)),
                                _createVNode(_component_el_tag, {
                                  size: "small",
                                  type: "info",
                                  style: {"margin-left":"8px"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_15
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (field.fieldtype==='text')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: formData[field.id],
                                    "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
                                    placeholder: "请输入",
                                    style: {"max-width":"500px"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (field.fieldtype==='textarea')
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      modelValue: formData[field.id],
                                      "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "请输入",
                                      style: {"max-width":"500px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : (field.fieldtype==='select')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 2,
                                        modelValue: formData[field.id],
                                        "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
                                        placeholder: "请选择",
                                        style: {"max-width":"500px","width":"100%"},
                                        filterable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseOptions(field.fieldoptions), (opt, oi) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: oi,
                                              label: opt,
                                              value: opt
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                    : (field.fieldtype==='dblist')
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 3,
                                          modelValue: formData[field.id],
                                          "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
                                          placeholder: "请选择",
                                          style: {"max-width":"500px","width":"100%"},
                                          filterable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDbOptions(field), (opt, oi) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: oi,
                                                label: opt.label,
                                                value: opt.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      : (field.fieldtype==='date')
                                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                            key: 4,
                                            modelValue: formData[field.id],
                                            "onUpdate:modelValue": ($event: any) => ((formData[field.id]) = $event),
                                            type: "date",
                                            placeholder: "请选择日期",
                                            "value-format": "YYYY-MM-DD",
                                            style: {"max-width":"500px","width":"100%"}
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (field.fieldtype==='attachment')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 5,
                                              style: {"width":"100%","max-width":"500px"},
                                              class: _normalizeClass({'attach_field':true,'attach_active':activeAttachFieldId.value===field.id}),
                                              onClick: ($event: any) => (setActiveAttachField(field.id))
                                            }, [
                                              (formData[field.id] && formData[field.id].length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData[field.id], (fileItem, fIdx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: fIdx,
                                                        style: {"display":"flex","align-items":"center","margin-bottom":"4px"}
                                                      }, [
                                                        _createElementVNode("a", {
                                                          href: `${apiname.value}${fileItem.url}`,
                                                          target: "_blank",
                                                          style: {"color":"#409EFF","margin-right":"8px","max-width":"300px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                                                        }, _toDisplayString(fileItem.name || '附件' + (fIdx+1)), 9, _hoisted_18),
                                                        _createVNode(_component_el_button, {
                                                          type: "danger",
                                                          link: "",
                                                          size: "small",
                                                          onClick: ($event: any) => (removeAttachFile(field.id, fIdx))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_19
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_20, [
                                                _createVNode(_component_el_upload, {
                                                  action: `${apiname.value}/frame/uploadfile1`,
                                                  "show-file-list": false,
                                                  "on-success": (res,file)=>onUploadSuccessSingle(field.id,res,file),
                                                  multiple: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_button, {
                                                      type: "primary",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(formData[field.id] && formData[field.id].length > 0 ? '追加附件' : '上传附件'), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["action", "on-success"]),
                                                (activeAttachFieldId.value===field.id)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      class: _normalizeClass(["attach_paste_tip", {'is-loading':pasteUploading.value}])
                                                    }, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴到此栏目'), 3))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ], 10, _hoisted_16))
                                          : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }),
              (currentFields.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_el_select, {
                      modelValue: nextHandler.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nextHandler).value = $event)),
                      placeholder: "请选择下一道填写人",
                      style: {"width":"300px"},
                      filterable: "",
                      clearable: _unref(allowComplete)
                    }, {
                      default: _withCtx(() => [
                        (_unref(allowComplete))
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              label: "无（信息已完善）",
                              value: ""
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentEditableUsers), (u) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: u,
                            label: u,
                            value: u
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "clearable"]),
                    (_unref(allowComplete))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(completeUsers).length === 0 ? '该模板未配置"可选无"人员名单，当前所有人可选"无"' : '选择后系统自动发送语音提醒'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "您不在该模板\"可选无\"的人员名单内，必须指定具体填写人"))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submitData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editMode.value ? '保存修改' : '提交保存'), 1)
                  ]),
                  _: 1
                }),
                (editMode.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: cancelEdit
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: resetForm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }))
              ])
            ]))
          : (selectedTemplateId.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 该模板暂无字段配置，请先在【数据收集模板】中配置字段 "))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_el_select, {
            modelValue: searchTemplateId.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTemplateId).value = $event)),
            placeholder: "请选择模板",
            style: {"width":"180px"},
            onChange: onSearchTemplateChange,
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateAllList.value, (tpl) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: tpl.id,
                  label: tpl.name,
                  value: String(tpl.id)
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: searchTemplateName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTemplateName).value = $event)),
            placeholder: "输入模板名称查询",
            style: {"width":"180px"},
            clearable: "",
            onClear: searchDataList,
            onKeyup: _withKeys(searchDataList, ["enter"])
          }, {
            prefix: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Search))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup"]),
          _createVNode(_component_el_date_picker, {
            modelValue: searchDateRange.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchDateRange).value = $event)),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD",
            style: {"width":"260px"},
            clearable: "",
            onChange: searchDataList
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            onClick: searchDataList
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            size: "default",
            loading: exporting.value,
            onClick: exportExcel
          }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchItems.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap","margin-bottom":"8px"}
          }, [
            (idx===0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "填写内容查询："))
              : (_openBlock(), _createElementBlock("span", _hoisted_37, "且")),
            _createVNode(_component_el_select, {
              modelValue: item.fieldid,
              "onUpdate:modelValue": ($event: any) => ((item.fieldid) = $event),
              placeholder: "选择字段",
              style: {"width":"150px"},
              clearable: "",
              onChange: ($event: any) => (onSearchItemFieldChange(item)),
              disabled: !searchTemplateId.value,
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchFieldList.value, (f) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: f.id,
                    label: f.fieldname,
                    value: f.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]),
            _createVNode(_component_el_select, {
              modelValue: item.empty,
              "onUpdate:modelValue": ($event: any) => ((item.empty) = $event),
              placeholder: "查询方式",
              style: {"width":"120px"},
              clearable: "",
              disabled: !item.fieldid
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "为空",
                  value: "empty"
                }),
                _createVNode(_component_el_option, {
                  label: "不为空",
                  value: "notempty"
                }),
                (isDateSearchField(item))
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 0,
                      label: "时间区间",
                      value: "range"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
            (item.empty === 'range')
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: item.daterange,
                  "onUpdate:modelValue": ($event: any) => ((item.daterange) = $event),
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"250px"},
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 3,
                  modelValue: item.text,
                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                  placeholder: "模糊查询内容",
                  style: {"width":"160px"},
                  clearable: "",
                  disabled: item.empty !== 'notempty',
                  onKeyup: _withKeys(loadDataList, ["enter"])
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Search))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onKeyup"])),
            (searchItems.value.length > 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 4,
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (removeSearchItem(idx))
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: addSearchItem
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: searchDataList,
            disabled: !searchTemplateId.value
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            size: "small",
            onClick: resetFieldSearch
          }, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (singleLine.value = !singleLine.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(singleLine.value ? '切换多行显示' : '切换单行显示'), 1)
            ]),
            _: 1
          }),
          _hoisted_43
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_el_table, {
          data: dataList.value,
          border: "",
          style: {"width":"100%"},
          "max-height": "550"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "380",
              align: "center",
              fixed: "left"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (editData(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (getLinkedProject(scope.row))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (openProjectInfo(getLinkedProject(scope.row)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "warning",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (openAllFiles(getLinkedProject(scope.row)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "warning",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (openVoiceDialog(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (deleteData(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "templatename",
              label: "数据模板",
              width: "150",
              "show-overflow-tooltip": singleLine.value
            }, null, 8, ["show-overflow-tooltip"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicTableColumns), (field) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: field.fieldid,
                label: field.fieldname,
                "min-width": "120",
                fixed: field.fieldname === '批次号' ? 'left' : false,
                "show-overflow-tooltip": singleLine.value
              }, {
                default: _withCtx((scope) => [
                  (getFieldValue(scope.row.fieldvalues, field.fieldid, 'type')==='attachment')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseAttachUrls(getFieldValue(scope.row.fieldvalues, field.fieldid, 'value')), (af, ai) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: ai,
                            href: `${apiname.value}${af}`,
                            target: "_blank",
                            style: {"color":"#409EFF","margin-right":"6px"}
                          }, "附件" + _toDisplayString(ai+1), 9, _hoisted_50))
                        }), 128)),
                        (parseAttachUrls(getFieldValue(scope.row.fieldvalues, field.fieldid, 'value')).length===0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, "无"))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (getFieldValue(scope.row.fieldvalues, field.fieldid, 'type')==='textarea')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle(singleLine.value ? {whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'} : {whiteSpace:'pre-wrap',wordBreak:'break-all'})
                        }, _toDisplayString(getFieldValue(scope.row.fieldvalues, field.fieldid, 'value') || '-'), 5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(getFieldValue(scope.row.fieldvalues, field.fieldid, 'value') || '-'), 1))
                ]),
                _: 2
              }, 1032, ["label", "fixed", "show-overflow-tooltip"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              prop: "nexthandler",
              label: "下一道填写人",
              width: "120",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.nexthandler)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.nexthandler), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createname",
              label: "提交人",
              width: "80",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createtime",
              label: "提交时间",
              width: "160",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_el_pagination, {
            "current-page": pageIndex.value,
            "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
            "page-size": pageSize.value,
            "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
            "page-sizes": [10,20,50],
            layout: "total, sizes, prev, pager, next",
            total: total.value,
            onSizeChange: loadDataList,
            onCurrentChange: loadDataList
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: voiceDialogShow.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((voiceDialogShow).value = $event)),
      title: "发送语音提醒",
      width: "400px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (voiceDialogShow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_58
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: sendVoiceNotify,
          loading: voiceSending.value
        }, {
          default: _withCtx(() => [
            _hoisted_59
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createVNode(_component_el_select, {
            modelValue: voiceSelectedUser.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((voiceSelectedUser).value = $event)),
            placeholder: "请选择提醒人员",
            style: {"width":"100%"},
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(voiceEditableUsers.value, (u) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: u,
                  label: u,
                  value: u
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_57, " 模板：" + _toDisplayString(voiceTemplateName.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_60, [
      _hoisted_61,
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", null, [
          _hoisted_63,
          _createVNode(_component_el_select, {
            modelValue: statTemplateId.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((statTemplateId).value = $event)),
            placeholder: "请选择数据模板",
            style: {"width":"260px"},
            filterable: "",
            onChange: onStatTemplateChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateAllList.value, (t) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: t.id,
                  label: t.name,
                  value: t.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_64,
          _createVNode(_component_el_select, {
            modelValue: statFieldId.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((statFieldId).value = $event)),
            placeholder: "请选择分组字段",
            style: {"width":"240px"},
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statFieldList.value, (f) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: f.id,
                  label: f.fieldname,
                  value: f.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: doStat
        }, {
          default: _withCtx(() => [
            _hoisted_65
          ]),
          _: 1
        })
      ]),
      (statRows.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, _toDisplayString(statFieldName.value) + " 统计结果（按次数从大到小）", 1),
              _createVNode(_component_el_table, {
                data: statRows.value,
                size: "small",
                border: "",
                "header-cell-style": {color:'#000',backgroundColor:'#fafafa'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "index",
                    label: "序号",
                    width: "60"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: statFieldName.value || '统计项',
                    "min-width": "160",
                    "show-overflow-tooltip": ""
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "count",
                    label: "次数",
                    width: "100",
                    sortable: ""
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", {
                ref_key: "statChartRef",
                ref: statChartRef,
                style: {"width":"100%","height":"320px"}
              }, null, 512)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_71, "请选择模板与分组字段后点击“统计”"))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: projectInfoShow.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((projectInfoShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "88%",
      top: "4vh"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", null, "项目信息 - " + _toDisplayString(curProject.value.projectname), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (projectInfoShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (projectInfoShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_73
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveProjectInfo,
          loading: projectInfoSaving.value
        }, {
          default: _withCtx(() => [
            _hoisted_74
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (projectInfoShow.value)
          ? (_openBlock(), _createBlock(ProjectInfoEdit, {
              key: 0,
              ref_key: "projectInfoRef",
              ref: projectInfoRef,
              projectuuid: curProject.value.uuid,
              projectname: curProject.value.projectname,
              projectcode: curProject.value.code,
              onSaved: onProjectInfoSaved
            }, null, 8, ["projectuuid", "projectname", "projectcode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ProjectAllFiles, {
      ref_key: "allFilesRef",
      ref: allFilesRef
    }, null, 512)
  ]))
}
}

})